import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';

library.add(faEnvelope, faPhone);

@Component({
  name: 'bpc-pages-layout',
  components: {},
})
export default class BpcPagesLayout extends Vue {
  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
}
